export default "__VITE_ASSET__e7b0b573__"